// src/services/EmpleadoService.js
import fetch from 'auth/FetchInterceptor';

const EmpleadoService = {};

EmpleadoService.getAll = function (params = {}) {
    return fetch({
        url: '/v1/empleados',
        method: 'get',
        params,
    });
};

EmpleadoService.getById = function (id) {
    return fetch({
        url: `/v1/empleados/${id}`,
        method: 'get',
    });
};

EmpleadoService.create = function (data) {
    return fetch({
        url: '/v1/empleados',
        method: 'post',
        data,
    });
};

EmpleadoService.update = function (id, data) {
    return fetch({
        url: `/v1/empleados/${id}`,
        method: 'put',
        data,
    });
};

EmpleadoService.remove = function (id) {
    return fetch({
        url: `/v1/empleados/${id}`,
        method: 'delete',
    });
};

EmpleadoService.buscarPorWhatsapp = function (whatsapp) {
    return fetch({
        url: '/v1/empleados/buscar',
        method: 'get',
        params: { whatsapp },
    });
};

EmpleadoService.updateEstado = function (id, activo) {
    return fetch({
        url: `/v1/empleados/${id}/estado`,
        method: 'patch',
        data: { activo },
    });
};

EmpleadoService.getGeocercas = function (id) {
    return fetch({
        url: `/v1/empleados/${id}/geocercas`,
        method: 'get',
    });
};

EmpleadoService.asignarGeocercas = function (id, geocercaIds) {
    return fetch({
        url: `/v1/empleados/${id}/geocercas`,
        method: 'post',
        data: { geocerca_ids: geocercaIds },
    });
};

export default EmpleadoService;